export default "__VITE_ASSET__CKzBdzv7__"